<template>
  <div class="accountInformation">
      <p>账户信息</p>
  </div>
</template>

<script>
  export default({
    name:'accountInformation'
  })
</script>

<style>
  .accountInformation{width: 100%;height: 100%;}
</style>



// WEBPACK FOOTER //
// src/page/memberCenter/accountInformation.vue